import { Chart } from "chart.js"
import { DARK_CHART_THEME } from "./chartTheme"

/**
 * Chart.js resolves anything a chart does not set itself from a single global defaults object —
 * tick labels, axis titles, legend text, tooltip colours. Setting those once covers every chart in
 * the app, including ones that never spell a colour out.
 *
 * The defaults in force at import time (before anything here has run) are captured as the light
 * baseline and restored verbatim when the user switches back, so light mode ends up byte-identical
 * to what Chart.js shipped.
 */
const LIGHT_DEFAULTS = {
  color: Chart.defaults.color,
  borderColor: Chart.defaults.borderColor,
  tooltipBackground: Chart.defaults.plugins?.tooltip?.backgroundColor,
  tooltipTitle: Chart.defaults.plugins?.tooltip?.titleColor,
  tooltipBody: Chart.defaults.plugins?.tooltip?.bodyColor,
  // Pie/doughnut segments are separated by a white hairline, which turns into a glaring ring
  // once the card goes dark.
  arcBorder: Chart.defaults.elements?.arc?.borderColor
}

export const applyChartDefaults = (isDark) => {
  if (isDark) {
    Chart.defaults.color = DARK_CHART_THEME.tick
    Chart.defaults.borderColor = DARK_CHART_THEME.grid
    if (Chart.defaults.plugins?.tooltip) {
      Chart.defaults.plugins.tooltip.backgroundColor = DARK_CHART_THEME.tooltipBg
      Chart.defaults.plugins.tooltip.titleColor = DARK_CHART_THEME.tooltipTitle
      Chart.defaults.plugins.tooltip.bodyColor = DARK_CHART_THEME.tooltipBody
    }
    if (Chart.defaults.elements?.arc) {
      Chart.defaults.elements.arc.borderColor = DARK_CHART_THEME.segmentBorder
    }
    return
  }

  Chart.defaults.color = LIGHT_DEFAULTS.color
  Chart.defaults.borderColor = LIGHT_DEFAULTS.borderColor
  if (Chart.defaults.plugins?.tooltip) {
    Chart.defaults.plugins.tooltip.backgroundColor = LIGHT_DEFAULTS.tooltipBackground
    Chart.defaults.plugins.tooltip.titleColor = LIGHT_DEFAULTS.tooltipTitle
    Chart.defaults.plugins.tooltip.bodyColor = LIGHT_DEFAULTS.tooltipBody
  }
  if (Chart.defaults.elements?.arc) {
    Chart.defaults.elements.arc.borderColor = LIGHT_DEFAULTS.arcBorder
  }
}

export default applyChartDefaults
